import React, { useState, useEffect } from 'react';
import MaskedInput from 'react-text-mask';
import PropTypes from 'prop-types';
import { useErrorHandler } from 'react-error-boundary';
import styles from './ReportForm.module.css';

import { IssuesService } from '../../../support/services/api';
import validate from '../../../support/services/validation';
import { createIssue } from '../../../support/services/validation/issues';

import { LoadingDots } from '..';

function ReportForm({ error }) {
  useErrorHandler(error);
  const [reportStatus, setReportStatus] = useState('closed');
  const [name, setName] = useState('');
  const [whatsapp, setWhatsapp] = useState('');

  const [inputError, setInputError] = useState({});

  const message = `\
    Requisição:
      - URL: ${error.response.config.request?.method} /${error.response.config.request?.url}
      - Dados: ${error.response.config.request?.data}

    Resposta:
      - Status: ${error.response.dataerror.response.datar.statusCode}
      - Código: ${error.response.datar.code}
      - Mensagem: ${error.response.datar.message}
      - Validação: ${error.response.datar.validation?.keys.join(',')}
  `;

  const getHelp = () => {
    validate(createIssue, { user: { name, whatsapp }, message })
      .then(() => {
        setReportStatus('gettingHelp');

        IssuesService(true).create({ name, whatsapp }, message)
          .then(() => setReportStatus('done'))
          .catch(() => {
            setReportStatus('failed');
          });
      })
      .catch((error) => {
        setInputError({ [error.path]: error.message });
        throw error;
      });
  };

  useEffect(() => {
    setInputError({});
  }, [name, whatsapp]);

  return (
    <div className={styles.componentContainer}>
      {{
        closed: (
          <div className={styles.reportMessageContainer}>
            <p className={styles.explainingText}>
              <strong>Precisa de ajuda? </strong>
              Caso esteja enfrentando algum erro inesperado, podemos entrar em contato com você.
            </p>

            <button type="button" className={styles.primaryButton} onClick={() => setReportStatus('opened')}>
              Preciso de ajuda
            </button>
          </div>
        ),
        opened: (
          <div className={styles.reportFormContainer}>
            <p className={styles.explainingText}>
              Ao clicar em
              <strong> Obter ajuda</strong>
              , receberemos um e-mail com as informações do erro ocorrido e conversaremos com você pelo
              <strong> Whatsapp</strong>
            </p>

            <div className={styles.reportFormInputs}>
              <div className={styles.floatingLabelInput}>
                <input
                  required
                  placeholder="Ex: Maria Silva"
                  id="name"
                  type="e-mail"
                  name="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <label htmlFor="name">
                  Nome
                  <span className={styles.inputError}>
                    {inputError['user.name'] ? '- ' : ''}
                    {inputError['user.name']}
                  </span>
                </label>
              </div>

              <div className={styles.floatingLabelInput}>
                <MaskedInput
                  value={whatsapp}
                  onChange={(e) => {
                    const cleaned = (`${e.target.value}`).replace(/\D/g, '');
                    setWhatsapp(cleaned);
                  }}
                  mask={['(', /[0-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                  placeholder="Ex: (99) 99999-9999"
                  id="whatsapp"
                  type="text"
                  name="whatsapp"
                />
                <label htmlFor="whatsapp">
                  Whatsapp
                  <span className={styles.inputError}>
                    {inputError['user.whatsapp'] ? '- ' : ''}
                    {inputError['user.whatsapp']}
                  </span>
                </label>
              </div>
            </div>

            <div className={styles.reportFormOptions}>
              <button type="button" className={styles.primaryButton} onClick={getHelp}>
                Obter ajuda
              </button>

              <span className={styles.buttonsSeparator}>|</span>

              <button type="button" className={styles.simpleButton} onClick={() => setReportStatus('closed')}>
                Cancelar
              </button>
            </div>
          </div>
        ),
        gettingHelp: (
          <div className={styles.reportMessageContainer}>
            <p className={styles.explainingText}>
              Pedindo ajuda
              <LoadingDots />
            </p>
            <p className={styles.explainingText}>
              (isso pode levar alguns segundos)
            </p>
          </div>
        ),
        done: (
          <div className={styles.reportMessageContainer}>
            <p className={styles.explainingText}>
              Seu pedido de ajuda foi enviado com
              <strong> sucesso</strong>
              ! Retornaremos o contato nas próximas horas.
            </p>
          </div>
        ),
        failed: (
          <div className={styles.reportMessageContainer}>
            <p className={styles.explainingText}>
              Falha no envio do seu pedido de ajuda.
              Pedimos desculpas pelo inconveniente. Caso queria falar conosco, envie um e-mail para:
              <p style={{ textAlign: 'center', margin: '10px' }}>
                <strong>aplicativo.locall@gmail.com</strong>
              </p>
            </p>
          </div>
        ),
      }[reportStatus]}
    </div>
  );
}

ReportForm.propTypes = {
  request: PropTypes.shape({
    url: PropTypes.string,
    method: PropTypes.string,
    data: PropTypes.string,
  }).isRequired,
  response: PropTypes.shape({
    code: PropTypes.string,
    message: PropTypes.string,
    statusCode: PropTypes.number,
    validation: PropTypes.shape({
      keys: PropTypes.array,
    }),
  }).isRequired,
};

export default ReportForm;
